import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import ScrollToTop from '../components/ScrollToTop';
import SEO from '../components/SEO';
import './FAQPage.css';

function FAQPage() {
  return (
    <div className="faq-page">
      <SEO 
        title="FAQs - iGames.ng | Free Casino Games Help & Support"
        description="Find answers to frequently asked questions about playing free casino games on iGames.ng. Learn about game types, registration, downloads, and more."
        canonical="https://igames.ng/faqs"
      />
      <Header />
      <main className="faq-page-content">
        <div className="faq-page-intro">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about playing free casino games on iGames.ng</p>
          <Link to="/" className="back-to-games-button">
            ← Back to Games
          </Link>
        </div>
        <FAQ />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default FAQPage;
